import { render, staticRenderFns } from "./GroupReport.vue?vue&type=template&id=14a7e7ff&scoped=true"
import script from "./GroupReport.vue?vue&type=script&lang=js"
export * from "./GroupReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a7e7ff",
  null
  
)

export default component.exports